import { defineComponent } from 'vue';
import { ArrowRightOutlined } from '@ant-design/icons-vue';
import ExcellentWorkList from '@/components/ExcellentWorkList.vue';
import { HomeService } from '@/services/home.service';
import { useService } from '@kaokei/use-vue-service';
export default defineComponent({
  name: 'ExcellentWorkArea',
  components: {
    ArrowRightOutlined: ArrowRightOutlined,
    ExcellentWorkList: ExcellentWorkList
  },
  setup: function () {
    var homeService = useService(HomeService);
    homeService.getUserCreationList();
    return {
      homeService: homeService
    };
  }
});